import React from 'react';
import { useSelector } from 'react-redux';

import selectors from 'state/selectors';
import utils from 'utils';

import Modal from 'components/Modal';

const DeleteConfirmationModal = () => {
  const t = utils.intl.useTranslator();
  const modalProps = useSelector(selectors.modal.getModalProps);

  return (
    <>
      <Modal.Header title={modalProps.title ?? t('delete_confirmation')} subtitle={modalProps.subtitle} />
      <Modal.Footer
        confirmText={t('continua')}
        confirmAction={modalProps.func}
        closeButtonText={t('annulla')}
      />
    </>
  );
};

export default DeleteConfirmationModal;
